export const DASHBOARD_ROUTES = {
  index: '/dashboard',
} as const;
